import React from 'react';
import classNames from 'classnames';
import ChatbotModel, { MessagesSettings } from '@mm/state/model/ChatbotModel';
import SettingSection from '../../../../components/SettingSection/SettingSection';
import { useChatbotCRUDActions } from '@mm/state/actions/ChatbotCRUDActions';
import PrimarySelect from '../../../../../../../common/components/PrimarySelect/PrimarySelect';
import { useDialogueDropdownState } from '../../../../../../../common/widgets/TextWidget/CreateEditButtonArea/CreateEditButtonArea';

type Props = {
  chatbot: ChatbotModel;
  className?: string;
};

export const MarketplaceSettings = ({ className, chatbot }: Props) => {
  const { messagesSettings } = chatbot;
  const { marketplacePageId } = messagesSettings || {};

  const { update } = useChatbotCRUDActions();

  const onChange = ({ id }: { id: number }) =>
    update({
      ...chatbot,
      messagesSettings: {
        ...messagesSettings,
        marketplacePageId: id,
      } as MessagesSettings,
    });

  const { dialogueDropdownOptions, selectedPage } =
    useDialogueDropdownState(marketplacePageId);

  return (
    <SettingSection
      className={classNames(className)}
      title="Facebook Marketplace"
    >
      <PrimarySelect
        showSearchFilter={true}
        placeholder="Marketplace Dialogue"
        className="question-button-active-tab-area__associated-dialogue-input"
        onChange={onChange}
        organizedOptions={dialogueDropdownOptions}
        value={selectedPage}
      />
    </SettingSection>
  );
};
